import React, { useState, useEffect } from "react";
import {
  EditOutlined,
  DeleteOutlined,
  UserOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { blue, red } from "@ant-design/colors";
import {
  Layout,
  Space,
  Button,
  Table,
  Popconfirm,
  Avatar,
  PageHeader,
  message,
  Select,
  Segmented,
  Input,
} from "antd";
import R2Footer from "../../../components/Footer";
import EmployeeService from "../../../services/EmployeeService";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const { Content } = Layout;

const EmployeeList = () => {
  const history = useHistory();
  const [employees, setEmployees] = useState([]);
  const [employeeType, setEmployeeType] = useState("all");
  const adminRestaurant = useSelector((state) => state.admin);

  const empType = {
    SERVER: "Servers",
    HOST: "Hosts",
    DELIVERY_DRIVER: "Drivers",
  };

  const columns = [
    {
      title: "",
      dataIndex: "",
      key: "",
      render: (_, record) => {
        return <Avatar size={46} icon={<UserOutlined />} />;
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone No",
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: "Emp Type",
      dataIndex: "",
      key: "",
      render: (_, record) => {
        return (
          <div
            style={{
              display: "flex",
            }}
          >
            {empType[record?.restaurant_roles[0].employee_type]}
          </div>
        );
      },
    },
    {
      title: "Emp ID",
      dataIndex: "job_title",
      key: "job_title",
      render: (_, record) => {
        return (
          <div
            style={{
              display: "flex",
            }}
          >
            {
              record.restaurant_roles.find(
                (item) => item.restaurant_id == adminRestaurant
              )?.employee_code
            }
          </div>
        );
      },
    },
    {
      title: "",
      render: (_, record) => {
        return (
          <div
            style={{
              display: "flex",
            }}
          >
            {employees.length > 0 && (
              <>
                <EditOutlined
                  style={{ color: blue[5] }}
                  onClick={() => {
                    history.push(`/business/employees/edit/${record.id}`);
                  }}
                />
                &nbsp;&nbsp;
                <Popconfirm
                  title="Sure to delete?"
                  onConfirm={() => deleteEmployee(record.id)}
                >
                  <DeleteOutlined className="ml-1" style={{ color: red[5] }} />
                </Popconfirm>
              </>
            )}
          </div>
        );
      },
    },
  ];

  const deleteEmployee = async (id) => {
    try {
      await EmployeeService.deleteEmployee(id);
      setEmployees((employees) => employees.filter((e) => e.id !== id));
    } catch (error) {
      message.error(
        "Error creating employee. Please check your input and try again."
      );
    }
  };

  useEffect(() => {
    getEmployees();
  }, []);

  const getEmployees = async () => {
    const data = await EmployeeService.getEmployees();
    if (data) setEmployees(data?.employees);
  };

  return (
    <Layout className="u-page-layout">
      <Content className="w-full">
        <Space className="w-full" direction="vertical">
          <PageHeader
            title="Employees"
            extra={[
              <Button
                type="primary"
                className="custom-btn"
                onClick={() => {
                  history.push(
                    "/business/employees/add?employee_type=" + employeeType
                  );
                }}
              >
                Add New Employee
              </Button>,
            ]}
          />
          <div className="emp-type-container content-container">
            <div>
              <Segmented
                size="large"
                options={["All Employees", "Employee Types"]}
              />
            </div>
            <div style={{ display: "flex" }}>
              <Input
                prefix={<SearchOutlined style={{ color: "#262626" }} />}
                placeholder="Search Employee"
              />
              <Select
                placeholder="Filter"
                style={{
                  width: 120,
                }}
                options={[
                  {
                    value: "Name",
                    label: "Name",
                  },
                  {
                    value: "PhoneNO",
                    label: "Phone No",
                  },
                ]}
              />
            </div>

            {/* <Radio.Group
              options={plainOptions}
              optionType="button"
              size="large"
              onChange={async (e) => {
                setEmployeeType(e.target.value)
                if(e.target.value!=='all'){
                  const data = await EmployeeService.getEmployeesByEmployeeType(
                    e.target.value
                  );
                  setEmployees(data?.employees?data?.employees:[]);
                }else{
                  const data = await EmployeeService.getEmployees();
                  setEmployees(data.employees);
                }
              }}
            /> */}
          </div>
          <div className="site-layout-background content-container box-shadow-card">
            <Table columns={columns} dataSource={employees} className="p-1"/>
          </div>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

export default EmployeeList;
